import { css } from '@emotion/css'

import { fontSize, fontWeight, spacing, shorthandHelper, colors } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    display: 'flex',
    alignItems: 'centre',
    padding: spacing.large,
  }),

  text: css({
    fontSize: fontSize.default,
    color: colors.oxfordBlue,
    fontWeight: fontWeight.semiBold,
    margin: shorthandHelper([0, 0, 0, spacing.small]),
  }),
}

export default styles
